import { MotorStatusMdl } from './MotorStatusMdl';
import { MotorProposal } from './MotorProposal';
import { mdlLicenceForEachCountryList } from './mdlLicenceForEachCountryList';
import { mdlChildrenUnder16List } from './mdlChildrenUnder16List';
export class BindMdl
{
    public ProductList: Array<ProductMaster>=new Array<ProductMaster>() ;
    public GenderList: Array<GenderMaster>=new Array<GenderMaster>();
    public IDTypeList: Array<IdTypeMaster>=new Array<IdTypeMaster>();
    public LicenceTypeList: Array<LicenseTypeMaster>=new Array<LicenseTypeMaster>();
    public VechilePlateList: Array<VehiclePlateLetterMaster>=new Array<VehiclePlateLetterMaster>();
    public VehcielUsageList: Array<VehcielUsageMaster>=new Array<VehcielUsageMaster>() ;
    public VehcielDefinitionList: Array<VehcielDefinitionMaster>=new Array<VehcielDefinitionMaster>();
    public MarStatusList: Array<MarStatusMaster>=new Array<MarStatusMaster>() ;
    public CoverMasterList: Array<CoverMaster>=new Array<CoverMaster>() ;
    public CityMasterList: Array<CityMaster>=new Array<CityMaster>();
    public NationalityMasterList: Array<NationalityMaster>=new Array<NationalityMaster>();
    public MakeMasterList: Array<MakeMaster>=new Array<MakeMaster>();
    public ModelMasterList: Array<ModelMaster>=new Array<ModelMaster>();
    public VechilePlateTypeMasterList: Array<VechilePlateTypeMaster>=new Array<VechilePlateTypeMaster>();
    public YearList: Array<YearMaster>=new Array<YearMaster>();
    public MotorProposalObj: MotorProposal;
    public RegionMasterList: Array<RegionMaster>=new Array<RegionMaster>();
    public VechileTypeMasterList: Array<VechileTypeMaster>=new Array<VechileTypeMaster>();
    public MakeModelMasterList: Array<MakeModelMaster>=new Array<MakeModelMaster>();
    public discountMasterList: Array<DiscountModel>=new Array<DiscountModel>();
    public VechileColorList: Array<VechileColorMaster>=new Array<VechileColorMaster>();
    public equippedList: Array<VehicleEquippedMaster>=new Array<VehicleEquippedMaster>();
    public restrainList: Array<RestraintsMaster>=new Array<RestraintsMaster>();
    public bodyList: Array<VehicleBodyMaster>=new Array<VehicleBodyMaster>();
    public smokeList: Array<SmokeMaster>=new Array<SmokeMaster>();
    public healthList: Array<HealthStatusMaster>=new Array<HealthStatusMaster>();
    public companyList: Array<prevCompanyMdl>=new Array<prevCompanyMdl>();
    public streetList: Array<streetMdl>=new Array<streetMdl>();
    public disList: Array<DistMdl>=new Array<DistMdl>();
    public deductableList: Array<DeductableMaster>=new Array<DeductableMaster>();
    public repairList: Array<RepairTypeMaster>=new Array<RepairTypeMaster>();
    public accList: Array<AccesMater>=new Array<AccesMater>();
    public bankList: Array<BankMaster>=new Array<BankMaster>();
    public eduList: Array<EducationMdl>=new Array<EducationMdl>();
    public profList: Array<ProfessionMdl>=new Array<ProfessionMdl>();
    public transmissionList: Array<TransmissionMdl>=new Array<TransmissionMdl>() ;
    public antiLockBrakingList: Array<AntiLockBrakingMdl>=new Array<AntiLockBrakingMdl>();
    public autoBrakingList: Array<AutomaticBrakingMdl>=new Array<AutomaticBrakingMdl>();
    public crusieControlList: Array<CruiseControlMdl>=new Array<CruiseControlMdl>();
    public adaptiveCruiseList: Array<AdaptiveCruiseMdl>=new Array<AdaptiveCruiseMdl>();
    public parkingSensorList: Array<RearParkingSensorMdl>=new Array<RearParkingSensorMdl>();
    public frontSensorList: Array<FrontSensorMdl>=new Array<FrontSensorMdl>();
    public frontCamList: Array<FrontCameraMdl>=new Array<FrontCameraMdl>();
    public rearCamList: Array<RearCameraMdl>=new Array<RearCameraMdl>();
    public degreeCamList: Array<DegreeCameraMdl>=new Array<DegreeCameraMdl>();
    public ExtinguisherList: Array<FireExtinguisherMdl>=new Array<FireExtinguisherMdl>();
    public mileageList: Array<ExpectedMileageMdl>=new Array<ExpectedMileageMdl>();
    public NumYearList: Array<numYearMdl>=new Array<numYearMdl>();
    public yesnoList: Array<YesNoMdl>=new Array<YesNoMdl>();
    public relationList: Array<RelationMdl>=new Array<RelationMdl>();
    public vehicleKeptList: Array<VehicleKeptMdl>=new Array<VehicleKeptMdl>();
    public RoadConvictionList: Array<RoadConviction>=new Array<RoadConviction>();
    public LicenceForEachCountryList: Array<mdlLicenceForEachCountryList> = new Array<mdlLicenceForEachCountryList>();
    public ChildrenUnder16List: Array<mdlChildrenUnder16List> = new Array<mdlChildrenUnder16List>();
    public Promos:Array<mdlPromos>=new Array<mdlPromos>();
    public AutoData:Array<mdlAutoData>=new Array<mdlAutoData>();

   
    public st: MotorStatusMdl=new MotorStatusMdl();
}

export class RoadConviction
{
    public RoadConviction_ID: number;
    public RoadConviction_Eng: string;
    public RoadConviction_Ar: string;
}


export class DiscountModel
{
  public  CoverDescription_Eng: string;
  public CoverDescription_Ar: string;
  public Rateper: number;
}
export class DistMdl
{
    public DisCode: number;
    public DistrictNameEng: string;
    public DistrictNameAr: string;
}
export class streetMdl
{
    public StreetCode: number;
    public StreetNameEng: string;
    public  StreetNameAr: string;
}
export class ProductMaster
{
    public ProductCode: string;
    public  ProdDescEn: string;
    public ProdDescAr: string;
    public SchemeDesc: string;
    public SchemeCode: string;
}
export class GenderMaster
{
   
    public gendercode: string;
    public genderdesc_En: string;
    public GenderDesc_Ar: string;
}

export class IdTypeMaster
{
    public CodeIdType: number;
    public Description_Eng: string;
    public Description_Ar: string;
}

export class LicenseTypeMaster
{
    public LicTypecode: number;
    public  LicType_DescEn: string;
    public LicType_DescAr: string;
}

export class VehiclePlateLetterMaster
{
    public PlateLetterCode: number;
    public PlateLetterEn_ar: string;
}

export class VehcielUsageMaster
{
    public VehUsagecode: number;
    public VehUsage_DescEn: string;
    public Vehusage_DescAr: string;
}

export class VehcielDefinitionMaster
{
    public VehDefcode: number;
    public  VehDef_DescEn: string;
    public VehDef_DescAr: string;
}

export class MarStatusMaster
{
    public  MarstatusCode: string;
    public MarstatusDesc_En: string;
    public MarstatusDesc_Ar: string;
}

export class CoverMaster
{
    public RatePer: string;
    public CoverDescription_En: string;
    public CoverDescription_Ar: string;
}

export class CityMaster
{
    public CITYNAME: string;
    public CITYNAMEAr: string;
    public CITYNAMEEn: string;
}

export class NationalityMaster
{
    public NationalityDesc: string;
    public NationalityDescAr: string;
    public NationalityDescEn: string;
}

export class MakeMaster
{
    public MakeCode: string;
    public MAKEDESC: string;
    public MAKEDESCAr: string;
} 

export class ModelMaster
{
    public MODELDESC: string;
    public MODELDESCAr: string;
    public MODELDESCEn: string;
    public MakeCode: string;
}

export class YearMaster
{
    public Year: string;
}

export class VechilePlateTypeMaster
{
    public VehPlateTypeCode: string;
    public PlateTypeDesc: string;
    public PlateTypeDescAr: string;
}

export class RegionMaster
{
    public CityCode: number;
    public Name: string;
    public NameAr: string;
    public RegionCode: string;
    public RegionName: string;
    public RegionNameAr: string;
}

export class VechileTypeMaster
{
    public ModelCode: string;
    public VechileTypeCodeAr: string;
    public VechileTypeCodeEn: string;
    public ModelSeatingCapacity: number;
}

export class MakeModelMaster
{
    public ModelCode: string;
    public MakeEn: string;
    public MakeAr: string;
}

export class VechileColorMaster
{
    public ColorId: number;
    public ColorDescEn: string;
    public ColorDescAr: string;
}

export class VehicleEquippedMaster
{
    public equippedID: number;
    public equippedDescEn: string;
    public equippedDescAr: string;
}

export class RestraintsMaster
{
    public restraintID: number;
    public restraintDescEn: string;
    public restraintDescAr: string;
}

export class VehicleBodyMaster
{
    public bodyID: number;
    public bodyDescEn: string;
    public bodyDescAr: string;
}

export class SmokeMaster
{
    public smokeID: number;
    public smokeDescEn: string;
    public smokeDescAr: string;
}

export class HealthStatusMaster
{
    public HealthID: number;
    public HealthDescEn: string;
    public HealthDescAr: string;
}

export class DeductableMaster
{
    public AgencyCode: number;
    public DeductableCode: string;
    public DeductableDescEn: string;
    public DeductableDescAr: string;
    public SumInsuredFrom: number;
    public SumInsuredTo: number;
}

export class RepairTypeMaster
{
    public AgencyCode: number;
    public AgencyDescEn: string;
    public AgencyDescAr: string;
}

export class AccesMater
{
    public AddOnAccessoriesCode: string;
    public AddOnAccessoriesEn: string;
    public AddOnAccessoriesAr: string;
}

export class BankMaster
{
    public BankCode: string;
    public BankDesc_Eng: string;
    public BankDesc_Ar: string;
    public CbidCode: string;
    public isSameCode: boolean;
}
export class prevCompanyMdl
{
    public companyCode: number;
    public companyNameEn: string;
    public companyNameAr: string;
}

export class EducationMdl
{
  public EducationCode: string;
  public EducationDesc_En: string;
  public EducationDesc_Ar: string;
}

export class ProfessionMdl
{
    public   Professioncode: string;
    public ProfessionDesc_Eng: string;
    public ProfessionDesc_Ar: string;
}


export class TransmissionMdl
{
    public Code: number;
    public  Desc_Eng: string;
    public Desc_Ar: string;
}

export class AntiLockBrakingMdl
{
    public  Code: number;
    public Desc_Eng: string;
    public Desc_Ar: string;
}

export class AutomaticBrakingMdl
{
    public  Code: number;
    public Desc_Eng: string;
    public Desc_Ar: string;
}
export class CruiseControlMdl
{
    public Code: number;
    public Desc_Eng: string;
    public  Desc_Ar: string;
}

export class AdaptiveCruiseMdl
{
    public Code: number;
    public  Desc_Eng: string;
    public  Desc_Ar: string;
}

export class RearParkingSensorMdl
{
    public Code: number;
    public  Desc_Eng: string;
    public  Desc_Ar: string;
}
export class FrontSensorMdl
{
    public Code: number;
    public  Desc_Eng: string;
    public  Desc_Ar: string;
}
export class FrontCameraMdl
{
    public  Code: number;
    public  Desc_Eng: string;
    public Desc_Ar: string;
}
export class RearCameraMdl
{
    public  Code: number;
    public  Desc_Eng: string;
    public  Desc_Ar: string;
}
export class DegreeCameraMdl
{
    public Code: number;
    public  Desc_Eng: string;
    public Desc_Ar: string;
}
export class FireExtinguisherMdl
{
    public  Code: number;
    public  Desc_Eng: string;
    public Desc_Ar: string;
}
export class ExpectedMileageMdl
{
    public  Mileage_Code: string;
    public  MileageDesc_En: string;
    public MileageDesc_Ar: string;
}
export class NumYear
{
    public NumYears: number;
}
export class numYearMdl
{
    public  numYearCode: string;
    public  numYear: string;
}
export class YesNoMdl
{
    public  Code: number;
    public  Desc_Eng: string;
    public  Desc_Ar: string;
}

export class RelationMdl
{
    public RelationId: number;
    public   RelationNameEn: string;
    public RelationNameAr: string;
}


export class VehicleKeptMdl
{
    public CODE: number;
    public  DESC_ENG: string;
    public  DESC_AR: string;
}

export class mdlPromos
{
    public PromoDesc: string;
    public  ProdDescAr: string;
    public Promocode: string;
}

export class mdlAutoData
{
    public VehicleDescId: number;
    public VehicleDesc: string;
    public MaxSuminsured: number;
    public MinSuminsured: number;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/BindMdl.ts